<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33" v-for="(loan, index) in loanList">
				<md-card class="md-card-stats" style="margin: 5px 0">
					<md-card-content style="text-align: left;">
						<p>
						<table>
							<tr>
								<td>លេខរៀង</td>
								<td class="dot">: </td>
								<td>{{ index + 1 }}</td>
							</tr>
							<tr>
								<td>ថ្ងៃកម្ជី</td>
								<td class="dot">: </td>
								<td>{{ config.datelify(loan.start_date) }}</td>
							</tr>
							<tr>
								<td>លេខកូដកម្ជី</td>
								<td class="dot">: </td>
								<td>{{ loan.hash_id }}</td>
							</tr>
							<tr>
								<td>ចំនួនកម្ជី</td>
								<td class="dot">: </td>
								<td>{{ config.moneylify(loan.amount) }}</td>
							</tr>
							<tr>
								<td>ថ្ងៃបង់ប្រាក់បន្ទាប់</td>
								<td class="dot">: </td>
								<td>
									<span v-if="loan.total_paid == loan.term || loan.status == 'fin'" class="active">Not
										Available</span>
									<span class="late"
										v-else-if="String(loan.next_payment).length >0 && config.timelify(loan.next_payment) == 'Late'">{{config.datelify(loan.next_payment)}}</span>
									<span class="active"
										v-else-if="String(loan.next_payment).length >0">{{config.datelify(loan.next_payment)}}
										({{config.timelifyKhmer(loan.next_payment)}})</span>
								</td>
							</tr>
							<tr>
								<td>ស្ថានភាព</td>
								<td class="dot">: </td>
								<td>
									<span class="active"
										v-if="loan.status == 'act'">{{config.getStatusKhmer(loan.status)}}</span>
									<span class="late" v-if="loan.status == 'fin'">{{config.getStatusKhmer(loan.status)}}</span>
								</td>
							</tr>
						</table>
						</p>
						<p style="text-align: right;margin: 0px">
							<router-link :to="'/my_loans/detail/' + loan.hash_id">
								<md-button class="md-raise md-success">បង្កាញបន្ថែម</md-button>
							</router-link>
						</p>
					</md-card-content>
				</md-card>
			</div>


			<!-- <md-table v-if="loanList.length > 0">
				<md-table-row>
					<md-table-head>រ.ល</md-table-head>
					<md-table-head>ថ្ងៃកម្ជី</md-table-head>
					<md-table-head>លេខកូដកម្ជី</md-table-head>
					<md-table-head>ចំនួនកម្ជី</md-table-head>
					<md-table-head>Client</md-table-head>
					<md-table-head>ថ្ងៃបង់ប្រាក់បន្ទាប់</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(loan, index) in loanList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>{{ config.datelify(loan.start_date) }}</md-table-cell>
					<md-table-cell>{{ loan.hash_id }}</md-table-cell>
					<md-table-cell>{{ config.moneylify(loan.amount) }}</md-table-cell>
					<md-table-cell><b>ID: {{loan.client_hash_id}}</b> ({{loan.name}})</md-table-cell>
					<md-table-cell>
						<span v-if="loan.total_paid == loan.term || loan.status == 'fin'" class="active">Not Available</span>
						<span class="late"
							v-else-if="String(loan.next_payment).length >0 && config.timelify(loan.next_payment) == 'Late'">{{config.datelify(loan.next_payment)}}</span>
						<span class="active"
							v-else-if="String(loan.next_payment).length >0">{{config.datelify(loan.next_payment)}}
							({{config.timelifyKhmer(loan.next_payment)}})</span>
					</md-table-cell>
					<md-table-cell>
						<span class="active" v-if="loan.status == 'act'">{{config.getStatusKhmer(loan.status)}}</span>
						<span class="late" v-if="loan.status == 'fin'">{{config.getStatusKhmer(loan.status)}}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/my_loans/detail/' + loan.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">View loan information</md-tooltip>
							</md-button>
						</router-link>
					</md-table-cell>
				</md-table-row>
			</md-table> -->
		</div>

		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this loan ?"
			md-content="This loan will be deleted and can't be restored." md-confirm-text="Delete" md-cancel-text="Cancel"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import StatsCard from '@/components/Cards/StatsCard'
	export default {
		components: { Datetime, StatsCard },
		created() {
			this.searchHandler();
			// this.getLocation();
			// this.getSettings();
			// this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				loadMore: true,
				loanList: []

			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/loan/search", {
					text: this.$store.state.authentication.hash_id,
					type: "",
					status: "",
					offset: more ? this.loanList.length : 0
				}).then(data => {
					this.loaded = true;
					// this.search.text = "";
					this.loanList = data.body.data;
				})

			}
		}
	}
</script>
<style scoped>
	.dot {
		padding: 0px 30px;
	}

	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ClientLoans/View.vue